import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { color, r, radius } from '../../theme/tokens';

// A row's placeholder where a risk chip would land, for a logged-out
// visitor's check only (STACK-563 mock, s8 and s12). Without them, a row
// with no chip during a check — or a supplement added after generation,
// which is never checked — would look exactly like a clean row.

const base = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: r(6),
  py: r(6),
  px: r(11),
  borderRadius: radius.sm,
  fontSize: r(12),
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  color: color.inkSoft,
};

export default function GuestCheckChip({ state }) {
  if (state === 'checking') {
    return (
      <Box component="span" data-testid="guest-check-chip-checking" sx={{ ...base, border: `${r(1)} dashed ${color.line}`, backgroundColor: color.paper }}>
        <CircularProgress size={r(12)} sx={{ color: color.inkSoft }} aria-hidden />
        Checking
      </Box>
    );
  }
  if (state === 'unchecked') {
    return (
      <Box component="span" data-testid="guest-check-chip-unchecked" sx={{ ...base, border: `${r(1)} solid ${color.inkMuted}`, backgroundColor: color.surface, fontWeight: 600 }}>
        <InfoOutlinedIcon sx={{ fontSize: r(14) }} aria-hidden />
        Not checked
      </Box>
    );
  }
  return null;
}

/** The line under an unchecked row's chips, saying why. */
export const GuestUncheckedNote = () => (
  <Typography sx={{ mt: r(8), fontSize: r(12.5), color: color.inkSoft, lineHeight: 1.45 }}>
    Added after your stack was made, so it wasn't checked against your medications.
  </Typography>
);
